/**
 * "How did you hear about StaxED?" options, asked once on the onboarding form.
 * Mirror of VALID_SIGNUP_SOURCES in backend/shared/validation.mjs -- keep the
 * two lists in sync (the backend rejects anything not listed there).
 */
export const SIGNUP_SOURCES = [
  { value: "google_search", label: "Google search" },
  { value: "ai_assistant", label: "ChatGPT / Gemini / other AI" },
  { value: "youtube", label: "YouTube" },
  { value: "instagram", label: "Instagram" },
  { value: "whatsapp", label: "WhatsApp" },
  { value: "friend", label: "A friend or classmate" },
  { value: "school_teacher", label: "School or teacher" },
  { value: "parent_family", label: "Parent or family" },
  { value: "other", label: "Somewhere else" },
] as const;

export type SignupSource = (typeof SIGNUP_SOURCES)[number]["value"];

export const SIGNUP_SOURCE_VALUES = SIGNUP_SOURCES.map((s) => s.value) as [
  SignupSource,
  ...SignupSource[],
];

export function signupSourceLabel(value: string | null | undefined): string {
  if (!value || value === "unknown") return "Not answered";
  return SIGNUP_SOURCES.find((s) => s.value === value)?.label ?? value;
}
